// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"826":"6d9a5ec4","835":"e88ebc17"}[chunkId] + ".chunk.js";
};